// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_of-0";
export var discountCodeInput = "_of-1";